"use client"

import clsx from "clsx"
import { useRef } from "react"
import { npPageWidthClassName, npSectionMtClassName } from "src/components/np-design/components/constants"

export type NpVideoProps = {
  videoSrc: string
  thumbnailSrc: string
  title?: string
}

export const NpVideo = ({ videoSrc, thumbnailSrc, title }: NpVideoProps) => {
  const sectionRef = useRef<any>(null)
  const videoRef = useRef<HTMLVideoElement>(null)

  return (
    <section
      ref={sectionRef}
      title={title}
      aria-label={"Video: " + title}
      className={clsx(npSectionMtClassName, npPageWidthClassName)}
    >
      <div
        className={clsx(
          "w-page:rounded-3xl relative flex aspect-video items-center justify-center overflow-hidden bg-black",
          npPageWidthClassName,
        )}
      >
        <video ref={videoRef} controls playsInline className="size-full">
          <source src={videoSrc} type="video/mp4" />
          <track kind="captions" srcLang="de" src={videoSrc} />
        </video>
      </div>
    </section>
  )
}
